import React from 'react';
import { arePageFlagsPending, EventSettingsContextType, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import AgendaDetails from './AgendaDetails';
import EventDetails from '../../shared/EventDetails';
import { Redirect } from 'react-router-dom';
import isEnabledRoute from '../../../hooks/use-enabled-route';

const AgendaWrapper = (): JSX.Element | null => {
  const data = useEventSettings() as EventSettingsContextType;
  const enabledRoute = isEnabledRoute(data?.landingPage);

  if (!data || arePageFlagsPending(data)) return null;

  if (!data.agendaEnabled) {
    return <Redirect to={enabledRoute} />;
  }

  return (
    <>
      <EventDetails details={data}/>
      <AgendaDetails event={data}/>
    </>
  );
};

export default AgendaWrapper;
